import type { SVGProps } from 'react';

const SvgList = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill={props.color}
      d="M6.75 6c0-.69.56-1.25 1.25-1.25h12a1.25 1.25 0 1 1 0 2.5H8c-.69 0-1.25-.56-1.25-1.25m0 6c0-.69.56-1.25 1.25-1.25h12a1.25 1.25 0 1 1 0 2.5H8c-.69 0-1.25-.56-1.25-1.25M8 16.75a1.25 1.25 0 1 0 0 2.5h12a1.25 1.25 0 1 0 0-2.5zm-4-3.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M5.25 18a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M4 7.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
    />
  </svg>
);

export default SvgList;
